/**
 * The keys of relevant projects stored in CMX / the translation service.
 */

export const ProjectKeys = Object.freeze({
    ARCADE_UI: "arcade-ui",
});
